var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute } from "@angular/router";
import { BaseComponent } from "../../views/base.component";
import { EventsService } from "../../lib/EventsService";
import { UserService } from "app/user/user.service";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { TranslateService } from "../../translate";
import { ModalService } from "../../views/modal/base_modal.component";
import { ProviderFormComponent } from "./provider_form.component";
import { RoleFormComponent } from "./role_form.component";
import dictionary from "dict/static.json";
import { SupportService } from "app/support/support/support.service";
import { FilterParams } from "../../models/filter_form.model";
import { mergeFilterParams } from "../../lib/lib";
var AclComponent = /** @class */ (function (_super) {
    __extends(AclComponent, _super);
    function AclComponent(eventsService, service, activatedRoute, filter, translate, modalService, supportService) {
        var _this = _super.call(this, eventsService, service, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.service = service;
        _this.activatedRoute = activatedRoute;
        _this.filter = filter;
        _this.translate = translate;
        _this.modalService = modalService;
        _this.supportService = supportService;
        _this.providers = [];
        _this.isProviderLoad = false;
        _this.roles = [];
        _this.isRoleLoad = false;
        return _this;
    }
    AclComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.isProviderLoad = true;
                        _a = this;
                        return [4 /*yield*/, this.service.getProviderList().toPromise()];
                    case 1:
                        _a.providers = _c.sent();
                        this.isProviderLoad = false;
                        this.isRoleLoad = true;
                        _b = this;
                        return [4 /*yield*/, this.service.getRoleList().toPromise()];
                    case 2:
                        _b.roles = _c.sent();
                        this.isRoleLoad = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AclComponent.prototype.addProvider = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal, r, provider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modal = this.modalService.open(ProviderFormComponent, {
                            title: this.__a('other.add'),
                        });
                        return [4 /*yield*/, modal.result];
                    case 1:
                        r = _a.sent();
                        if (!(r !== 'cancel')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.service.addProvider(r).toPromise()];
                    case 2:
                        provider = _a.sent();
                        this.providers.push(provider);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AclComponent.prototype.editProvider = function (provider) {
        return __awaiter(this, void 0, void 0, function () {
            var modal, r, updatedProvider_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modal = this.modalService.open(ProviderFormComponent, {
                            title: this.__a('other.edit'),
                        });
                        modal.componentInstance.form.setData(provider);
                        modal.componentInstance.filter.reset();
                        modal.componentInstance.filter.filterParams = this.filter.getCopyFilterParams(mergeFilterParams(new FilterParams(), provider.filter));
                        return [4 /*yield*/, modal.result];
                    case 1:
                        r = _a.sent();
                        if (!(r !== 'cancel')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.service.editProvider(r).toPromise()];
                    case 2:
                        updatedProvider_1 = _a.sent();
                        Object.keys(updatedProvider_1)
                            .forEach(function (key) { return provider[key] = updatedProvider_1[key]; });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AclComponent.prototype.deleteProvider = function (provider) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.deleteProvider(provider).toPromise()];
                    case 1:
                        _a.sent();
                        this.providers = this.providers.filter(function (p) { return p._id !== provider._id; });
                        return [2 /*return*/];
                }
            });
        });
    };
    AclComponent.prototype.addRole = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal, r, userId, role;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modal = this.modalService.open(RoleFormComponent, {
                            title: this.__a('other.add'),
                            providerNameList: this.providers.map(function (p) { return p.name; }),
                            roleNameList: dictionary.roleList,
                        });
                        return [4 /*yield*/, modal.result];
                    case 1:
                        r = _a.sent();
                        if (!(r !== 'cancel')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.supportService.searchByEmail(r.email).toPromise()];
                    case 2:
                        userId = (_a.sent()).userId;
                        r.userId = userId;
                        return [4 /*yield*/, this.service.addRole(r).toPromise()];
                    case 3:
                        role = _a.sent();
                        this.roles.push(role);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AclComponent.prototype.editRole = function (role) {
        return __awaiter(this, void 0, void 0, function () {
            var modal, r, updatedRole_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modal = this.modalService.open(RoleFormComponent, {
                            title: this.__a('other.edit'),
                            providerNameList: this.providers.map(function (p) { return p.name; }),
                            roleNameList: dictionary.roleList,
                        });
                        modal.componentInstance.setRole(role);
                        return [4 /*yield*/, modal.result];
                    case 1:
                        r = _a.sent();
                        if (!(r !== 'cancel')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.service.editRole(r).toPromise()];
                    case 2:
                        updatedRole_1 = _a.sent();
                        Object.keys(updatedRole_1)
                            .forEach(function (key) { return role[key] = updatedRole_1[key]; });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AclComponent.prototype.deleteRole = function (role) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.deleteRole(role).toPromise()];
                    case 1:
                        _a.sent();
                        this.roles = this.roles.filter(function (r) { return r._id !== role._id; });
                        return [2 /*return*/];
                }
            });
        });
    };
    return AclComponent;
}(BaseComponent));
export { AclComponent };
